import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { APP_INSIGHT_CS } from './config/config';

const appInsights = new ApplicationInsights({
  config: {
    connectionString: APP_INSIGHT_CS,
    enableAutoRouteTracking: true,
    /* ...Other Configuration Options... */
    // https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript
  }
});

// https://github.com/microsoft/ApplicationInsights-JS#readme
export class AppInsights {

  public loadAppInsights(): void {
    appInsights.loadAppInsights();
  }

  public trackPageView(): void {
    appInsights.trackPageView();
  }

  public trackEvent(eventString: string): void {
    appInsights.trackEvent({ name: eventString })
  }

  // public trackPageViewPerformance() {
  //   appInsights.trackPageViewPerformance({name : 'somepage', url: 'some url'});
  // }

  public trackException(err: string): void {
    appInsights.trackException({ exception: new Error(err) });
  }

  public trackTrace(msg: string): void {
    appInsights.trackTrace({ message: msg });
  }

  public trackMetric(n: string, avg: number): void {
    appInsights.trackMetric({ name: n, average: avg });
  }


  // public trackDependencyData(absUrl: string, resCode: number, method: string, id: string) {
  //   appInsights.trackDependencyData({ absoluteUrl: absUrl, responseCode: resCode, method: method, id: id });
  // }

  public startTrackPage(pageName: string): void {
    appInsights.startTrackPage(pageName);
  }


  public stopTrackPage(pageName: string, url: string, props: any): void {
    // appInsights.stopTrackPage("pageName", null, { customProp1: "some value" });
    appInsights.stopTrackPage(pageName, url, props);
  }

  public startTrackEvent(et: any): void {
    appInsights.startTrackEvent(et);
  }


  // public stopTrackEvent(et: any, url: string, props: any) {
  //   // appInsights.stopTrackEvent("event", null, { customProp1: "some value" });
  // }


  public flush(): void {
    appInsights.flush();
  }


}
